<template>
  <div class="head-meta">
    <Head>
      <Title>{{ title }}</Title>
      <Meta
        name="description"
        :content="story.name"
      />
      <Meta
        name="keywords"
        :content="keywords"
      />
    </Head>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  story: { required: true },
})

const route = useRoute()

const title = computed(() => {
  if (props.story.name == "Home") return "Videlio"
  return `${props.story.name} - Videlio`
})

// **********************************************************************
// KEYWORDS
// **********************************************************************
const tags = computed(() => {
  let _tags = []

  if (props.story?.content?.tags) {
    _tags = [..._tags, ...props.story.content.tags.split("\n")]
  }

  if (props.story?.content?.meta?.[0]?.location) {
    _tags.push(props.story.content.meta[0].location)
  }

  if (props.story?.content?.type) {
    _tags.push(props.story.content.type)
  }

  return _tags
})

const keywords = computed(() => {
  return tags.value.join(", ")
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
